import React from 'react';

import { Box, Sx } from '@mantine/core';
import KiloAlert from 'components/KiloAlert';

interface SharedPaymentMethodsAlertProps {
  sx?: Sx;
}

const SharedPaymentMethodsAlert = ({ sx }: SharedPaymentMethodsAlertProps): JSX.Element => {
  return (
    <Box sx={sx}>
      <KiloAlert variantStyle='warning'>
        Payment methods added to a main account or any of its subaccounts will be shared across the entire
        account group.
      </KiloAlert>
    </Box>
  );
};

export default SharedPaymentMethodsAlert;
